import { Box, Typography, Button } from "@mui/material";
import Confetti from "react-confetti";
import { colors } from "../../ui/colors";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { 
  CheckCircle, 
  ArrowForward 
} from "@mui/icons-material";

export const CongratulationsScreen = () => {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    const timer = setTimeout(() => setShowContent(true), 300);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        overflow: "hidden",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      {/* Simplified confetti */}
      <Confetti 
        width={windowSize.width}
        height={windowSize.height}
        numberOfPieces={100}
        recycle={false}
        gravity={0.2}
        colors={['#FB8E00', '#FFC107']}
      />

      {/* Minimalist main card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 480,
          borderRadius: "16px",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
          p: { xs: 4, md: 6 },
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(251, 142, 0, 0.1)",
          transform: showContent ? "translateY(0)" : "translateY(20px)",
          opacity: showContent ? 1 : 0,
          transition: "all 400ms ease-out",
        }}
      >
        {/* Main icon */}
        <Box
          sx={{
            display: "inline-flex",
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: `linear-gradient(135deg, ${colors.orange.base} 0%, ${colors.yellow.base} 100%)`,
              boxShadow: "0 8px 24px rgba(251, 142, 0, 0.25)",
            }}
          >
            <CheckCircle
              sx={{
                fontSize: 40,
                color: "white",
              }}
            />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "28px", md: "32px" },
            mb: 2,
            color: colors.gray[800],
          }}
        >
          Congratulations! 
        </Typography>

        {/* Main message */}
        <Box sx={{ mb: 4 }}>
          <Typography
            sx={{
              color: colors.gray[600],
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 500,
              lineHeight: 1.6,
              mb: 1,
            }}
          >
            Your account has been created successfully
          </Typography>
          <Typography
            sx={{
              color: colors.gray[500],
              fontSize: { xs: "15px", md: "16px" },
            }}
          >
            Welcome to{" "}
            <Box
              component="span"
              sx={{
                fontWeight: 600,
                color: colors.orange.base,
              }}
            >
              Flownect
            </Box>
          </Typography>
        </Box>

        {/* Button */}
        <Button
          onClick={() => {
            navigate("/")
            window.location.reload();
          }}
          sx={{
            borderRadius: "8px",
            height: "48px",
            px: 4,
            background: "#000000",
            color: "white",
            fontWeight: 600,
            fontSize: "16px",
            textTransform: "none",
            "&:hover": {
              background: "#000000"},
          }}
          variant="contained"
          disableElevation
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            Go to Flownect!
            <ArrowForward sx={{ fontSize: 18 }} />
          </Box>
        </Button>
      </Box>
    </Box>
  );
};